// German translations for recipes page
// Location: src/i18n/locales/de/recipes.ts

export const recipes = {
    title: 'Deine Rezepte',
    subtitle: 'Alle Rezepte aus deinem Ernährungsplan',
    subtitleVip: 'Rezepte aus deinem {{count}}-Tage-Ernährungsplan',
    subtitleBasic: 'Einfache Rezeptbeschreibungen aus deinem Plan',

    searchPlaceholder: 'Rezepte durchsuchen...',

    filters: {
        all: 'Alle',
        breakfast: 'Frühstück',
        lunch: 'Mittagessen',
        dinner: 'Abendessen',
        snack: 'Imbiss',
    },

    showing: '{{count}} Rezepte angezeigt',
    clearFilters: 'Filter zurücksetzen',
    noResults: 'Keine Rezepte gefunden',

    day: 'Tag {{day}}',
    minutes: 'Min',

    emptyState: {
        title: 'Noch keine Rezepte',
        description: 'Erstelle deinen Ernährungsplan, um personalisierte Rezepte zu erhalten, die auf deine Ziele und Vorlieben zugeschnitten sind.',
        createPlan: 'Plan mit KI erstellen',
        infoTitle: 'Was du erhältst',
        infoDescription: 'Sobald du deinen Ernährungsplan erstellst, hast du Zugriff auf alle deine Mahlzeitenrezepte an einem Ort. Suchen, nach Mahlzeitentyp filtern und detaillierte Kochanleitungen anzeigen.',
    },

    vipInfo: {
        title: 'Upgrade auf VIP für detaillierte Rezepte',
        description: 'Mit dem VIP-Plan erhältst du Schritt-für-Schritt-Anleitungen mit exakten Mengenangaben, Kochzeiten und Tipps für jedes Rezept!',
    },

    generating: 'Wird generiert...',
    generatingTitle: 'Rezept wird generiert...',
    generatingDescription: 'Wir finden das perfekte Rezept für deine Mahlzeit. Das dauert etwa 5-10 Sekunden.',
    generatingButton: 'Rezept wird generiert...',
    generateButton: 'Vollständiges Rezept generieren',
    generationTime: 'Dauert etwa 5-10 Sekunden',
    generationFailed: 'Generierung fehlgeschlagen',
    tryAgain: 'Erneut versuchen',

    noRecipeTitle: 'Noch kein Rezept',
    noRecipeDescription: 'Diese Mahlzeit hat noch kein detailliertes Rezept. Generiere jetzt eines, um Zutaten, Anleitung und mehr zu sehen!',

    vipRequired: 'VIP-Funktion erforderlich',
    vipRequiredDescription: 'Upgrade auf VIP, um detaillierte Rezepte mit Zutaten, Schritt-für-Schritt-Anleitungen und mehr zu generieren!',

    calories: 'Kalorien',
    kcal: 'kcal',
    servings: 'Portionen',
    portions: 'Portionen',
    totalTime: 'Gesamtzeit',
    cuisine: 'Küche',

    nutritionalInfo: 'Nährwertangaben',
    protein: 'Protein',
    carbs: 'Kohlenhydrate',
    fat: 'Fett',

    ingredients: 'Zutaten',
    addToShoppingList: 'Zur Einkaufsliste hinzufügen',
    neverShowIngredient: 'Diese Zutat nie wieder anzeigen',

    instructions: 'Anleitung',
    viewFullRecipe: 'Vollständiges Rezept & Anleitung ansehen',
};